export const ASSISTANT_VARIABLE_PATH_MAX_CHARACTERS = 200;
